export interface PassMapNode {
  id: string;
  number: string;
  x: number;
  y: number;
}

export interface PassConnection {
  source: string;
  target: string;
  weight: number;
}

export interface PassMapMock {
  nodes: PassMapNode[];
  connections: PassConnection[];
  timeline: {
    minute: number;
    maxMinute: number;
  };
  playerOrder: string[];
}

export const passMapMocks: Record<"home" | "away", PassMapMock> = {
  home: {
    nodes: [
      { id: "1", number: "1", x: 0.08, y: 0.52 },
      { id: "2", number: "2", x: 0.24, y: 0.72 },
      { id: "41", number: "41", x: 0.32, y: 0.46 },
      { id: "6", number: "6", x: 0.4, y: 0.3 },
      { id: "33", number: "33", x: 0.53, y: 0.35 },
      { id: "36", number: "36", x: 0.65, y: 0.45 },
      { id: "23", number: "23", x: 0.6, y: 0.63 },
      { id: "12", number: "12", x: 0.72, y: 0.78 },
      { id: "19", number: "19", x: 0.78, y: 0.31 },
      { id: "14", number: "14", x: 0.86, y: 0.56 },
      { id: "20", number: "20", x: 0.9, y: 0.75 },
    ],
    connections: [
      { source: "1", target: "2", weight: 6 },
      { source: "1", target: "41", weight: 5 },
      { source: "1", target: "6", weight: 5 },
      { source: "2", target: "41", weight: 5 },
      { source: "2", target: "23", weight: 4 },
      { source: "2", target: "12", weight: 3 },
      { source: "41", target: "33", weight: 5 },
      { source: "33", target: "36", weight: 4 },
      { source: "36", target: "19", weight: 3 },
      { source: "33", target: "19", weight: 4 },
      { source: "19", target: "14", weight: 3 },
      { source: "14", target: "20", weight: 4 },
      { source: "36", target: "23", weight: 3 },
      { source: "23", target: "12", weight: 5 },
      { source: "12", target: "20", weight: 4 },
      { source: "23", target: "20", weight: 4 },
      { source: "23", target: "14", weight: 3 },
    ],
    timeline: {
      minute: 64,
      maxMinute: 96,
    },
    playerOrder: ["2", "1", "41", "6", "33", "36", "23", "12", "19"],
  },
  away: {
    nodes: [
      { id: "52", number: "52", x: 0.15, y: 0.23 },
      { id: "27", number: "27", x: 0.28, y: 0.44 },
      { id: "8", number: "8", x: 0.36, y: 0.63 },
      { id: "18", number: "18", x: 0.45, y: 0.32 },
      { id: "7", number: "7", x: 0.54, y: 0.55 },
      { id: "9", number: "9", x: 0.62, y: 0.45 },
      { id: "3", number: "3", x: 0.68, y: 0.7 },
      { id: "44", number: "44", x: 0.75, y: 0.28 },
      { id: "11", number: "11", x: 0.82, y: 0.5 },
      { id: "10", number: "10", x: 0.9, y: 0.67 },
    ],
    connections: [
      { source: "52", target: "27", weight: 4 },
      { source: "27", target: "8", weight: 5 },
      { source: "8", target: "3", weight: 3 },
      { source: "8", target: "18", weight: 4 },
      { source: "18", target: "7", weight: 6 },
      { source: "7", target: "9", weight: 5 },
      { source: "7", target: "44", weight: 2 },
      { source: "9", target: "11", weight: 4 },
      { source: "44", target: "11", weight: 3 },
      { source: "11", target: "10", weight: 4 },
      { source: "3", target: "10", weight: 2 },
      { source: "27", target: "18", weight: 3 },
      { source: "27", target: "7", weight: 3 },
    ],
    timeline: {
      minute: 58,
      maxMinute: 90,
    },
    playerOrder: ["52", "27", "8", "18", "7", "9", "3", "44", "11", "10"],
  },
};
